// Set the data
const productHandle =
  document.querySelector(".js-product").dataset.productHandle;
const recentProducts = [];
const recentProductsFromStorage = localStorage.recentProducts;

// Set the array items from the cookie items
if (recentProductsFromStorage) {
  // Parse the localStorage
  const recentProductsJson = JSON.parse(recentProductsFromStorage);

  // If only one item, push to the array
  if (typeof recentProductsJson === "string") {
    recentProducts.push(recentProductsJson);
  }
  // If array of items, push the array to array
  else if (Array.isArray(recentProductsJson)) {
    recentProducts.push(...recentProductsJson);
  }
}

// Check if the current product is in the array
const found = recentProducts.find((item) => item === productHandle);
// Remove it and add it as the last item if found
if (found) {
  recentProducts.splice(recentProducts.indexOf(found), 1);
}

// Add the current product to the end of the array
recentProducts.push(productHandle);

// Set the recent products localStorage
localStorage.recentProducts = JSON.stringify(recentProducts);

// Debug
// console.log(localStorage.recentProducts);
